module.exports = __webpack_public_path__ + "img/9.159d7f8f.jpg";